import { useState, useEffect } from "react";
import { CTA_URL } from "../../../constants/cta";
import RegisterLink from "../../../components/RegisterLink";

function MarqueeBar() {
  return (
    <div
      className="w-full overflow-hidden"
      style={{
        background: "rgba(16,92,232,0.12)",
        borderBottom: "1px solid rgba(16,92,232,0.2)",
        height: "32px",
      }}
    >
      <div
        className="flex items-center h-full whitespace-nowrap"
        style={{ animation: "marqueeScroll 28s linear infinite" }}
      >
        <span className="text-xs font-medium px-8" style={{ color: "#7ab0f8", letterSpacing: "0.06em" }}>
          Welcome TO Ace96au Asia&apos;s Biggest Online Casino ,Experience top-tier Slot Games &amp; Live Casino Entertainment with real rewards.
          &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
          New Register FREE 10$ &nbsp;&middot;&nbsp; Welcome Bonus 100% &nbsp;&middot;&nbsp; Daily First Deposit 30% &nbsp;&middot;&nbsp; Live Welcome Bonus 50% &nbsp;&middot;&nbsp; Sport Welcome Bonus 50% &nbsp;&middot;&nbsp; Weekly Cash Back Up to 6%
          &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
          Welcome TO Ace96au Asia&apos;s Biggest Online Casino ,Experience top-tier Slot Games &amp; Live Casino Entertainment with real rewards.
          &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
          New Register FREE 10$ &nbsp;&middot;&nbsp; Welcome Bonus 100% &nbsp;&middot;&nbsp; Daily First Deposit 30% &nbsp;&middot;&nbsp; Live Welcome Bonus 50% &nbsp;&middot;&nbsp; Sport Welcome Bonus 50% &nbsp;&middot;&nbsp; Weekly Cash Back Up to 6%
        </span>
      </div>
    </div>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className="fixed top-0 left-0 w-full z-50 transition-all duration-500"
        style={{
          background: scrolled
            ? "rgba(3, 17, 43, 0.95)"
            : "transparent",
          backdropFilter: scrolled ? "blur(20px)" : "none",
          borderBottom: scrolled ? "1px solid rgba(16,92,232,0.2)" : "none",
          boxShadow: scrolled ? "0 4px 32px rgba(3,17,43,0.7)" : "none",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-18" style={{ height: "72px" }}>
          {/* Logo / Brand */}
          <a href="/" className="flex items-center group">
            <img
              src="https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/b8500fc5b880150736c6d516c60a553d.png"
              alt="ACE96AU"
              className="h-10 w-auto object-contain transition-all duration-300 group-hover:brightness-110"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
            {["Pokies", "Bonuses", "Live Casino", "Sports", "Banking"].map((item, i) => {
              const hrefs = ["#games", "#bonuses", "#sports", CTA_URL, "#payment"];
              const isCta = hrefs[i] === CTA_URL;
              return isCta ? (
                <RegisterLink
                  key={item}
                  trackLabel="navbar-sports"
                  className="relative text-slate-300 hover:text-white transition-colors duration-200 group whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif", letterSpacing: "0.05em" }}
                >
                  {item}
                  <span className="absolute -bottom-1 left-0 w-0 h-px group-hover:w-full transition-all duration-300"
                    style={{ background: "linear-gradient(90deg, #105CE8, #4d8ef5)" }}
                  ></span>
                </RegisterLink>
              ) : (
                <a
                  key={item}
                  href={hrefs[i]}
                  className="relative text-slate-300 hover:text-white transition-colors duration-200 group whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif", letterSpacing: "0.05em" }}
                >
                  {item}
                  <span className="absolute -bottom-1 left-0 w-0 h-px group-hover:w-full transition-all duration-300"
                    style={{ background: "linear-gradient(90deg, #105CE8, #4d8ef5)" }}
                  ></span>
                </a>
              );
            })}
          </nav>

          {/* Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <RegisterLink
              trackLabel="navbar-login-desktop"
              className="px-5 py-2 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 hover:scale-105 inline-flex items-center justify-center"
              style={{
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(16,92,232,0.4)",
                color: "#7ab0f8",
                backdropFilter: "blur(8px)",
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(16,92,232,0.7)";
                (e.currentTarget as HTMLAnchorElement).style.boxShadow = "0 0 16px rgba(16,92,232,0.35)";
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(16,92,232,0.4)";
                (e.currentTarget as HTMLAnchorElement).style.boxShadow = "none";
              }}
            >
              Log in
            </RegisterLink>
            <RegisterLink
              trackLabel="navbar-signup-desktop"
              className="btn-glow px-5 py-2 rounded-lg text-sm whitespace-nowrap inline-flex items-center justify-center"
            >
              <span>SIGN UP</span>
            </RegisterLink>
          </div>

          {/* Hamburger */}
          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors"
            style={{ background: "rgba(16,92,232,0.15)", border: "1px solid rgba(16,92,232,0.25)" }}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} style={{ color: '#105CE8' }}></i>
          </button>
        </div>
      </header>

      {/* Marquee bar — shown below nav when scrolled, always visible when at top */}
      <div
        className="w-full"
        style={{
          position: "absolute",
          top: "72px",
          left: 0,
          right: 0,
          opacity: scrolled ? 0 : 1,
          transition: "opacity 0.3s",
          pointerEvents: scrolled ? "none" : "auto",
        }}
      >
        <MarqueeBar />
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          className="fixed inset-0 z-40 flex flex-col pt-20 px-6 gap-2 md:hidden"
          style={{
            background: "rgba(3,17,43,0.97)",
            backdropFilter: "blur(24px)",
          }}
        >
          {["Pokies", "Bonuses", "Live Casino", "Sports", "Banking"].map((item, i) => {
            const hrefs = ["#games", "#bonuses", "#sports", "#sports", "#payment"];
            return (
              <a
                key={item}
                href={hrefs[i]}
                onClick={() => setMenuOpen(false)}
                className="text-slate-200 text-lg font-medium py-4 border-b transition-colors"
                style={{ borderColor: "rgba(16,92,232,0.2)" }}
              >
                {item}
              </a>
            );
          })}
          <div className="flex flex-col gap-3 mt-6">
            <RegisterLink
              trackLabel="navbar-login-mobile"
              className="w-full py-3 rounded-lg font-semibold cursor-pointer text-center inline-block"
              style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(16,92,232,0.4)", color: "#7ab0f8" }}
            >
              Log in
            </RegisterLink>
            <RegisterLink
              trackLabel="navbar-signup-mobile"
              className="btn-glow w-full py-3 rounded-lg inline-flex items-center justify-center"
            >
              <span>SIGN UP</span>
            </RegisterLink>
          </div>
        </div>
      )}
    </>
  );
}
